/**
 * Created by jv on 2019-10-17 (10:41).
 */
const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");
const GameBonusIcon = require("!raw-loader!Images/icons/game-bonus.svg");

require("Styles/components/business-model-dialog.scss");
require("Styles/components/game-bonus-dialog.scss");

class GameBonusDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("game-bonus-dialog-");

    this.bonus = options.bonus;
    this.circular = options.circular === true;

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
  }

  get bonus() {
    return this._bonus;
  }

  set bonus(bonus) {
    this._bonus = bonus;

    if (utils.isNotNull(this.$dialog) && this.$dialog.length) {
      this.$dialog.find("[data-gbd-bonus]").text(this.bonus);
    }
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog game-bonus-dialog'>" +
      "<div class='modal-content'>" +
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up game bonus dialog - bonus: %d", this.bonus);

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      let $gameBonusContent = $("<div class='gbd__content'></div>");

      let $gameBonusTop = $("<div class='gbd__top'></div>");

      $gameBonusTop.append(`<div class="gbd__icon">${GameBonusIcon}</div>`);
      $gameBonusTop.append(`<h4 class="gbd__title">${LanguageManager.getValueForKey("serious_game.business_mode.game_bonus.dialog.title")}</h4>`);

      let $gameBonusBottom = $("<div class='gbd__bottom'></div>");

      if (this.circular) {
        $gameBonusBottom.append(`<p>${LanguageManager.getValueForKey("serious_game.business_mode.game_bonus.dialog.circular.text")}</p>`);
      } else {
        $gameBonusBottom.append(`<p>${LanguageManager.getValueForKey("serious_game.business_mode.game_bonus.dialog.text")}</p>`);
      }

      let $gameBonusDataGroup = $("<div class='gbd__data-group'></div>");
      $gameBonusDataGroup.append(`<div class='game-bonus__data-value game-bonus-data game-bonus-data__points' data-gbd-bonus="${this.bonus}">${this.bonus}</div>`);

      $gameBonusBottom.append($gameBonusDataGroup);

      $gameBonusContent.append($gameBonusTop);
      $gameBonusContent.append($gameBonusBottom);

      $dialogContent.append($gameBonusContent);

      this.setUpCloseRoundEventListeners();
    }
  }

  show() {
    this.$dialog.modal("show");
  }

  hide() {
    this.$dialog.modal("hide");
  }

  setUpDialogEventListeners() {

  }

  setUpCloseRoundEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });
  }
}

export default GameBonusDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/game-bonus-dialog.js